import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Mix from './mixins'
import store from './store'

Vue.config.productionTip = false
Vue.mixin(Mix);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
